import { FeedbackRequest } from "@/clients/models/FeedbackRequest";
import { FeedbackService } from "@/clients/services/FeedbackService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useSendFeedback = () => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [QueryKeys.FEEDBACK],
    mutationFn: async (body: FeedbackRequest) => {
      const user = guardGetUserFromLocalStorage();
      return FeedbackService.updateFeedbackApiV1FeedbackPut(user.id, body);
    },
  });
  return {
    sendFeedback: mutate,
    isSendingFeedback: isPending,
    error,
  };
};
